import { CdnClient } from '@vista-digital/cdn-client';
import { ApiClientProvider } from '../types/api-client-provider';
/**
 * CDN Client - used to build CDN URLs for media assets (e.g. Film poster images).
 */
export class CdnClientProvider extends ApiClientProvider {
    constructor() {
        super(...arguments);
        this.update = (cdnConfig) => {
            this.client = new CdnClient(cdnConfig);
        };
    }
}
//# sourceMappingURL=provider.js.map